module.exports = __webpack_public_path__ + "img/Conversation.721fbfdc.svg";